import React from 'react';
import PropTypes from 'prop-types';
import { I18n as I } from 'react-redux-i18n';

import engine from '../../static/img/engine.png';
import killometers from '../../static/img/killometers48.png';
import piston from '../../static/img/piston48.png';
import transmission from '../../static/img/transmission.png';
import greece_map from '../../static/img/greece_map.png';
import cyprus_map from '../../static/img/cyprus_map.png';
import calendar from '../../static/img/calendar48.png';
import model from '../../static/img/model.png';
import modelTruck from '../../static/img/truck48.png';
import modelOther from '../../static/img/other48.png';
import modelMoto from '../../static/img/motocyrcle48.png';
import modelPickup from '../../static/img/pickup48.png';
import noImg from '../../static/img/notAvailable.png';

import { getBrand } from 'lib/Utils';
import { kilometers } from 'vdlib';

import {
  isNil,
  ifNullOrWhitespace,
  PartyTypes,
  AuctionStatuses,
  formatCurrency,
  toDateTimeString,
} from 'vdlib';

import LookupsHelper from 'lib/LookupsHelper';

import {
  Card,
  Tag,
  Typography,
  Descriptions,
  Tooltip,
  Alert,
  Icon,
} from 'antd';

const { Paragraph } = Typography;

const defaultClassName = 'col-12';

const { Meta } = Card;

const gridStyle = {
  width: '50%',
  height: '120px',
  textAlign: 'center',
};

const imageStyle = {
  height: '48px',
  width: '48px',
  textAlign: 'center',
};

const titleStyle = {
  fontWeight: 400,
  fontSize: 14,
  color: 'rgba(0, 0, 0, 0.45)',
};

const descriptionStyle = {
  fontWeight: 500,
  fontSize: 14,
  color: 'rgba(0, 0, 0, 0.85)',
};

const FolderDataPane = ({
  auction,
  className,
  partyType,
  viewOnly,
  showInsurance,
  status,
}) => {
  if (!auction) return <div className="row" />;

  return (
    <div
      className={`auction-data-pane ${ifNullOrWhitespace(
        className,
        defaultClassName
      )}`}
    >
      <Card style={{ marginBottom: 5 }}>
        <Card.Grid style={gridStyle}>
          <img style={imageStyle} src={getBrand(auction.VehicleBrand)} alt="" />
          <Meta
            description={
              <span style={descriptionStyle}>{auction.VehicleBrand}</span>
            }
            title={<span style={titleStyle}>{I.t('BRAND')}</span>}
          />
        </Card.Grid>
        <Card.Grid style={gridStyle}>
          <img
            style={imageStyle}
            src={
              auction.VehicleTypeID && auction.VehicleTypeID === 1
                ? model
                : auction.VehicleTypeID && auction.VehicleTypeID === 2
                ? modelTruck
                : auction.VehicleTypeID && auction.VehicleTypeID === 3
                ? modelMoto
                : auction.VehicleTypeID && auction.VehicleTypeID === 4
                ? modelPickup
                : modelOther
            }
            alt=""
          />
          <Meta
            description={
              <Tooltip title={auction.VehicleModel}>
                <Paragraph ellipsis={{ rows: 1 }} style={descriptionStyle}>
                  {auction.VehicleModel}
                </Paragraph>
              </Tooltip>
            }
            title={<span style={titleStyle}>{I.t('MODEL')}</span>}
          />
        </Card.Grid>
        <Card.Grid style={gridStyle}>
          <img style={imageStyle} src={engine} alt="" />
          <Meta
            description={
              <Tooltip title={auction.VehicleEngine}>
                <Paragraph ellipsis={{ rows: 1 }} style={descriptionStyle}>
                  {auction.VehicleEngine}
                </Paragraph>
              </Tooltip>
            }
            title={<span style={titleStyle}>{I.t('ENGINE_TYPE')}</span>}
          />
        </Card.Grid>
        <Card.Grid style={gridStyle}>
          <img style={imageStyle} src={killometers} alt="" />
          <Meta
            description={
              <span style={descriptionStyle}>
                {kilometers(auction.Kilometers)}
              </span>
            }
            title={<span style={titleStyle}>{I.t('KILOMETERS')}</span>}
          />
        </Card.Grid>
        <Card.Grid style={gridStyle}>
          <img style={imageStyle} src={piston} alt="" />
          <Meta
            description={
              <Tooltip title={auction.VehicleEngineCapacity}>
                <Paragraph ellipsis={{ rows: 1 }} style={descriptionStyle}>
                  {auction.VehicleEngineCapacity}
                </Paragraph>
              </Tooltip>
            }
            title={<span style={titleStyle}>{I.t('ENGINE_CAPACITY')}</span>}
          />
        </Card.Grid>
        <Card.Grid style={gridStyle}>
          <img style={imageStyle} src={calendar} alt="" />
          <Meta
            description={
              <span style={descriptionStyle}>
                {auction.VehicleRegistrationYear}
              </span>
            }
            title={<span style={titleStyle}>{I.t('YEAR_CREATED')}</span>}
          />
        </Card.Grid>
        <Card.Grid style={gridStyle}>
          <img style={imageStyle} src={transmission} alt="" />
          <Meta
            description={
              <span style={descriptionStyle}>
                {' '}
                {I.t(
                  LookupsHelper.getDescription(
                    'gearBoxes',
                    auction.GearBoxID
                  ) || ''
                )}{' '}
              </span>
            }
            title={<span style={titleStyle}>{I.t('GEARBOX')} </span>}
          />
        </Card.Grid>
        <Card.Grid style={gridStyle}>
          <img
            style={imageStyle}
            src={auction && auction.CountryID === 51 ? cyprus_map : greece_map}
            alt=""
          />
          <Meta
            description={
              <Tooltip
                title={I.t(
                  LookupsHelper.getDescription('regions', auction.RegionID) ||
                    ''
                )}
              >
                <Paragraph ellipsis={{ rows: 1 }} style={descriptionStyle}>
                  {' '}
                  {I.t(
                    LookupsHelper.getDescription('regions', auction.RegionID) ||
                      ''
                  )}{' '}
                </Paragraph>
              </Tooltip>
            }
            title={<span style={titleStyle}>{I.t('REGION')}</span>}
          />
        </Card.Grid>
      </Card>
    </div>
  );
};

FolderDataPane.propTypes = {
  auction: PropTypes.object,
  className: PropTypes.string,
  partyType: PropTypes.string,
  viewOnly: PropTypes.bool,
  status: PropTypes.string,
};

export default FolderDataPane;
